import { dayToNumber, getAllHours, getAllMins } from '@/constants/DayConvertToNumber';
import _, { mapKeys, camelCase, omit } from 'lodash';
import moment from 'moment';
import { connect } from 'dva';
import { getMapStateToProps } from '@/utils/utils';

export const DATEFORMAT = 'YYYY-MM-DD';
const TIMEFORMAT = 'HH:mm';

const AllMins = getAllMins();
const AllHours = getAllHours();

//从storage里面读出来slot值
const SLOTMINS = localStorage.getItem('popsup-ca-slot-time')
  ? Number(localStorage.getItem('popsup-ca-slot-time'))
  : 15;

export const getvalidPickUpDates = (availableHours: any) => {
  const result = availableHours
    .filter((x: any) => x.open === 1)
    .map((x: any) => ({
      dateIndex: dayToNumber[x.day],
      dateLabel: x.day,
      period: [{ start: x.start, end: x.end, preparationTime: x.preparationTime }],
    }));

  const getGroupedResult = () => {
    let ret = {};
    _.forEach(result, (value: any) => {
      //第一种 这个value的key已经在array里面了
      if (Object.keys(ret).includes(String(value.dateIndex))) {
        ret[value.dateIndex].period.push(value.period[0]);
      }

      //第二种 这个value的key不在array里面
      if (!Object.keys(ret).includes(String(value.dateIndex))) {
        ret[value.dateIndex] = value;
      }
    });
    return ret;
  };

  return getGroupedResult();
};

export const getAvailableTime = (period: any[]) => {
  let ret: any[] = [];

  //所有数据
  period.map((x: any) => {
    const startHour = moment(x.start, TIMEFORMAT);
    const endHour = moment(x.end, TIMEFORMAT);
    for (
      let time = startHour;
      // 时间早于endHour或者时间等于endHour的时候，才是合法的
      time.isBefore(endHour) || time.isSame(endHour);
      time = time.add(Number(x.preparationTime), 'm')
    ) {
      const currentHourTime = Number(time.format(TIMEFORMAT).split(':')[0]);
      if (!ret.includes(currentHourTime)) {
        ret.push({
          hour: currentHourTime,
          time: Number(time.format(TIMEFORMAT).split(':')[1]),
        });
      }
    }
    return x;
  });

  //架构 - 有小时没有分钟
  let finalRet = [...new Set(ret.map((x: any) => x.hour))].map((x: any) => ({
    hour: x,
    timePeriod: [],
  }));

  //加上分钟
  _.forEach(finalRet, (item: any) => {
    //这个hour对应的时间不在timeList里面就加上

    const assigendHourRecord = ret.filter((x: any) => x.hour === item.hour);

    assigendHourRecord.map((x: any) => {
      if (!item.timePeriod.includes(x.time)) {
        item.timePeriod.push(x.time);
      }
      return x;
    });
  });

  return finalRet;
};

export const getDisabledHours = (period: any[], isSelectedDatToday: boolean) => {
  //这个是所有的hour的集合
  const retHourOnly = getAvailableTime(period).map((x: any) => x.hour);
  const allTimesInThisDay = getAllTimeOfOneCertainPeriod(getAvailableTime(period));

  //如果不是选择的天数不是今天 则按照原本的情况返回
  if (!isSelectedDatToday) {
    return AllHours.filter((x: any) => !retHourOnly.includes(x));
  }

  const currentTimeWhitPrepareTime = moment().add(SLOTMINS, 'm');
  const currentTimeHour = Number(currentTimeWhitPrepareTime.format(TIMEFORMAT).split(':')[0]);

  //筛选时间
  const filteredRetHourOnly = retHourOnly.filter((x: any) => {
    //小时数大于当前 则全部保留
    if (x > currentTimeHour) {
      return true;
    }
    //小时数等于当前
    if (x === currentTimeHour) {
      //把这个小时对应的所有时间都摘出来
      const timeListOfThisHour = allTimesInThisDay.filter(
        (time: any) => Number(time.format(TIMEFORMAT).split(':')[0]) === currentTimeHour,
      );
      //一个个对比过去 只要有一个时间比当前时间大则返回为true
      let ret = false;
      for (let i = 0; i < timeListOfThisHour.length; i++) {
        if (timeListOfThisHour[i].isAfter(currentTimeWhitPrepareTime)) {
          ret = true;
          break;
        }
      }
      return ret;
      //对比结束
    }
    return false;
  });

  return AllHours.filter((x: any) => !filteredRetHourOnly.includes(x));
  //只要ret里面有的
};

export const getDisabledMins = (isSelectedDateToday: boolean, selectedHour: any, period: any[]) => {
  const minList: number[] = getAvailableTime(period).filter((x: any) => x.hour === selectedHour)[0]
    .timePeriod;

  //!!这里还是要先判断现在是不是当天 因为不是当天就要从头开始算时间
  //当前时间加上准备时间 15m TODO --
  const currentTimeWhitPrepareTimeToCompare = isSelectedDateToday
    ? moment().add(SLOTMINS, 'm')
    : moment('00:00', TIMEFORMAT);

  //这里要判断一下目前选到的这个hour是不是和当前的currentTimeWhitPrepareTime的hour一样
  //一样的话就表示正在当前小时内 后面的时间不能选
  if (
    selectedHour === Number(currentTimeWhitPrepareTimeToCompare.format(TIMEFORMAT).split(':')[0])
  ) {
    //把能选的时间都列出来
    const allAvailableTimeOfTisHour = minList.map((x: any) =>
      moment(`${selectedHour}:${x}`, TIMEFORMAT),
    );
    let ret: any = [];
    for (let i = 0; i < allAvailableTimeOfTisHour.length; i++) {
      const itemTime = allAvailableTimeOfTisHour[i];
      if (allAvailableTimeOfTisHour[i].isAfter(currentTimeWhitPrepareTimeToCompare)) {
        ret.push(itemTime);
      }
    }
    const retOfMinOnly: number[] = ret.map((x: any) => Number(x.format(TIMEFORMAT).split(':')[1]));
    //把能选的时间都列出来 -- END
    return AllMins.filter((x: any) => !retOfMinOnly.includes(x));
  }

  //不一样就都返回了就行了
  return AllMins.filter((x: any) => !minList.includes(x));
};

export const getResetedRenderTime = (targetTimeHour: number, periods: any[]) => {
  const resetedMin = getAvailableTime(periods).filter((x: any) => x.hour === targetTimeHour)[0]
    .timePeriod[0];

  return moment(`${targetTimeHour}:${resetedMin}`, TIMEFORMAT);
};

export const getTimeValueWhenDateChanges = (period: any[], selectedDay: any) => {
  const periodsOfThisCertenDay = getAvailableTime(period);

  //算出现在的时间
  const currentTime = moment(moment(), TIMEFORMAT);
  //判断选择的这一天是不是今天
  const isSelectedDatToday =
    selectedDay.format(DATEFORMAT) === moment().format(DATEFORMAT) ? true : false;

  const currentAvailablTimeOfCurrentTime = getAllTimeOfOneCertainPeriod(periodsOfThisCertenDay);

  //如果不是今天 直接返回此天的第一个时间即可
  if (!isSelectedDatToday) {
    return currentAvailablTimeOfCurrentTime[0];
  }

  //这里如果是今天的话 那么它能选择的时间就必须从当前的时刻往后算
  //以当前时间为准一个个对比

  //当前时间 + 15分钟后再去比较。 避免出现当前时间是15:40, autofill的值却是15:45的情况。
  let renderTime: any = currentTime.add(SLOTMINS, 'm');
  for (let i = 0; i < currentAvailablTimeOfCurrentTime.length; i++) {
    if (currentAvailablTimeOfCurrentTime[i].isAfter(renderTime)) {
      renderTime = currentAvailablTimeOfCurrentTime[i];
      break;
    }
  }

  //没有变的话给undefined
  if (!currentAvailablTimeOfCurrentTime.includes(renderTime)) {
    renderTime = undefined;
  }

  return renderTime;
};

export const getAllTimeOfOneCertainPeriod = (period: any[]) => {
  //把一个period的里面的所有元素都扩展成时间
  let currentAvailablTimeOfCurrentTime: any = [];
  period.map((day: any) => {
    _.forEach(day.timePeriod, min => {
      currentAvailablTimeOfCurrentTime.push(moment(`${day.hour}:${min}`, TIMEFORMAT));
    });
  });

  return currentAvailablTimeOfCurrentTime;
};

export const getDatePickerOptions = (
  allTimeObj: any,
  enableAsap: boolean,
  advancedDays: number,
  enableOrderDeadline: boolean,
  orderDeadlineTime: string,
) => {
  //当前时间加上准备时间 15m TODO --
  const currentTimeWhitPrepareTime = moment().add(SLOTMINS, 'm');

  //首先 获取到当前在用户选择时的时间 -- 这里把它的星期给抓出来
  let validDateIndexSummary: any[] = [];
  _.forEach(allTimeObj, (value: any) => {
    validDateIndexSummary.push(value.dateIndex);
  });

  // validDateIndexSummary [1,2,3,4,5] 只有周一到周五营业

  let ret: any = [];
  //从这一天往后连续加14天 所有的有效时间都算上
  for (let i = 0; i < 14; i++) {
    const clonedTime = _.cloneDeep(currentTimeWhitPrepareTime).add(i, 'd');
    if (validDateIndexSummary.includes(clonedTime.day())) {
      ret.push(clonedTime.format(DATEFORMAT));
    }
  }
  // ret ["2021-03-12","2021-03-15", ... ] -- 这就是接下来14天里它营业的所有时间

  //如果接下来的两周里没有一天营业 则直接undefined
  if (ret.length === 0) {
    return undefined;
  }
  //如果ret里面的第一天和今天不一样 并且此时不enable asap advacnedDays === 0
  if (ret[0] !== currentTimeWhitPrepareTime.format('YYYY-MM-DD') && advancedDays === 0) {
    return undefined;
  }

  //这里要处理一下
  //因为这一天的第一天很有可能已经太晚了而导致没有任何有效时间可以选
  const firstDayOfRender = moment(ret[0], DATEFORMAT).day();
  //把第一天对应的所有的可选时间都列出来
  const allAvailableTimeInThisFirstDay = getAllTimeOfOneCertainPeriod(
    getAvailableTime(allTimeObj[firstDayOfRender]?.period),
  );

  //currentTimeIsIncludeInTheFirstDayTimeList moment[] -- ['12:00', '12:30'...]

  //和currentTime去对比 看看是不是能够把这个currentTime给包含进去

  //!!这个地方要做一下判断 因为如果第一天就和当前天不一样的话
  //!! 那么时间不能按刚才的currentTimeWhitPrepareTime 对比 而要从00：00开始
  const currentTimeWhitPrepareTimeToCompare =
    ret[0] === currentTimeWhitPrepareTime.format('YYYY-MM-DD')
      ? currentTimeWhitPrepareTime
      : moment('00:00', TIMEFORMAT);

  let currentTimeIsIncludeInTheFirstDayTimeList: boolean = false;
  let showAsapAsInNormalSlot: boolean = false;
  for (let i = 0; i < allAvailableTimeInThisFirstDay.length; i++) {
    const item = allAvailableTimeInThisFirstDay[i];
    if (currentTimeWhitPrepareTimeToCompare.isBefore(item)) {
      //current在前面 item在后面 则证明这一天是有效的
      currentTimeIsIncludeInTheFirstDayTimeList = true;
    }
    if (i < allAvailableTimeInThisFirstDay.length - 1) {
      // [1,2,3,4] 4-1=3 i = 0,1,2
      const nextItem = allAvailableTimeInThisFirstDay[i + 1];
      if (
        item.isBefore(currentTimeWhitPrepareTimeToCompare) &&
        nextItem.isAfter(currentTimeWhitPrepareTimeToCompare) &&
        nextItem.diff(item) === SLOTMINS * 60000 //这个表示分钟对应的毫秒
      ) {
        //判断时间是不是在正常的15m内的slot里面 在的话显示asap
        showAsapAsInNormalSlot = true;
      }
    }
  }

  //这里首先要处理enableOrderDeadline已经打开的情况 --因为原来的情况都是没有这一项的
  if (enableOrderDeadline && orderDeadlineTime) {
    //用currentTimeWhitPrepareTimeToCompare和orderDeadlineTime去比

    //如果现在这个currentTimeWhitPrepareTimeToCompare已经超过orderDeadlineTime
    //则第一天不应该出现应该在ret里面删除掉第一天
    if (currentTimeWhitPrepareTimeToCompare.isAfter(moment(orderDeadlineTime, TIMEFORMAT))) {
      const cuttedRet = ret.slice(1, ret.length);
      if (cuttedRet.length <= advancedDays + 1) {
        return [...cuttedRet];
      }
      return [...cuttedRet.slice(0, advancedDays + 1)];
    }
  }

  //如果第一天有效 什么叫有效？--
  //这里如果包含了就返回第一个值
  if (currentTimeIsIncludeInTheFirstDayTimeList) {
    // 当天是营业的
    if (ret[0] === currentTimeWhitPrepareTimeToCompare.format(DATEFORMAT)) {
      if (showAsapAsInNormalSlot) {
        //这个时间是否在区间里面
        if (enableAsap) {
          //这里首先要判断是不是允许asap
          if (ret.length <= advancedDays + 1) {
            return ['asap', ...ret];
          }
          return ['asap', ...ret.slice(0, advancedDays + 1)];
        }
        if (ret.length <= advancedDays + 1) {
          return [...ret];
        }
        return [...ret.slice(0, advancedDays + 1)];
      } else {
        if (ret.length <= advancedDays + 1) {
          return [...ret];
        }
        return [...ret.slice(0, advancedDays + 1)];
      }
    } else {
      //当天不营业
      if (ret.length <= advancedDays) {
        return ret;
      }
      return [...ret.slice(0, advancedDays)];
    }
  }
  //如果第一天无效
  //如果没有包含的话 这个第一个天数就相当于作废了 直接删除掉
  if (!currentTimeIsIncludeInTheFirstDayTimeList) {
    if (ret.length <= advancedDays + 1) {
      return ret.slice(1, ret.length);
    }
    return ret.slice(1, advancedDays + 1);
  }
};

export const getInitialValueOfSelectedDay = (periods: any[], currentSelectedDate: 'string') => {
  //当前时间加上准备时间 15m TODO --

  const allAvailableTimeInThisFirstDay = getAllTimeOfOneCertainPeriod(getAvailableTime(periods));

  //allAvailableTimeInThisFirstDay moment[] -- ['12:00', '12:30'...]

  //这里有一个判断 要看当前传进来的这个时间 （currentSelectedDate）
  //是不是和currentTimeWhitPrepareTime的天数一致
  const currentTimeWhitPrepareTime = moment().add(SLOTMINS, 'm');

  //如果一致的话 就从现在的时间往后选
  //如果不一致的话 00：00开始往后选
  const timeToCompare =
    currentSelectedDate === currentTimeWhitPrepareTime.format(DATEFORMAT)
      ? currentTimeWhitPrepareTime
      : moment('00:00', TIMEFORMAT);

  let renderTime: any = undefined;
  for (let i = 0; i < allAvailableTimeInThisFirstDay.length; i++) {
    const item = allAvailableTimeInThisFirstDay[i];
    //取第一个可选的时间就行了
    if (item.isAfter(timeToCompare)) {
      renderTime = item;
      break;
    }
  }
  return renderTime;
};
